import React from 'react';
import Svg from 'rp-react-svg-icon';

const Spinner = () => (
    <div className="sb-results__spinner col-md-12">
        <Svg
            iconName="spinner"
            size="2XL"
            className="loading-icon"
        />
    </div>
);

export default Spinner;



// WEBPACK FOOTER //
// ./src/client/components/Spinner.js